import { Instagram, Menu } from 'lucide-react';

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'components/ui/select';
import { Button } from 'components/ui/button';
import { useSidebar } from 'features/providers';

export const InstagramHeader = () => {
  const { toggle } = useSidebar();

  return (
    <header className="z-10 h-[60px] sticky top-0 bg-white border-b">
      <div className="flex items-center justify-between h-16 px-4 mx-auto">
        <div className="flex items-center gap-4">
          <Button variant="outline" size="icon" className="lg:!hidden" onClick={toggle}>
            <Menu className="w-4 h-4" />
          </Button>
          <div className="flex items-center gap-2">
            <Instagram className="h-6 w-6 text-pink-600" />
            <h1 className="text-sm font-semibold md:text-xl">Instagram Manager</h1>
          </div>
        </div>
        <div className="flex items-center gap-4">
          <Select defaultValue="ru">
            <SelectTrigger className="w-auto">
              <SelectValue placeholder="Language" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="ru">Русский</SelectItem>
              <SelectItem value="kz">Казахский</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    </header>
  );
};
